import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import range from 'lodash.range';
import {
    rangeHoursFrom, rangeHoursTo, tHoursTo, tHoursFrom,
} from '../../statics';

const mapStateToProps = (state) => {
    const { date_from, date_to } = state.Leads.Lead_profile.Lead_transport;
    return { date_from, date_to };
}; const
    { RangePicker } = DatePicker;

export default connect(mapStateToProps, null)(class ChooseDateTimeView extends Component {
  chooseDayTime = (moment, date, status) => {
      if (status === 'DatePicker') {
          let min = +date.slice(-2) + 30; let
              hour = +date.slice(-5, -3);
          if (min > 59) {
              min -= 60;
              hour === 23 ? hour = '00' : hour += 1;
          }
          const date_to = `${date.slice(0, -5) + hour.toString()}:${min.toString()}`;
          this.props.dispatch({
              type: 'SET_TRANSPORT_OPTIONS_DATE', date_from: date, date_to, date_type: 'DATETIME',
          });
      } else if (status === 'RangePicker') {
          this.props.dispatch({
              type: 'SET_TRANSPORT_OPTIONS_DATE', date_from: date[0], date_to: date[1], date_type: 'DATERANGE',
          });
      } else {
          this.props.dispatch({ type: 'SET_TRANSPORT_OPTIONS_DATE', date, date_type: 'DATE' });
      }
  };

  chooseTimeRangeFrom = (moment, time) => this.props.dispatch({ type: 'SET_TRANSPORT_OPTIONS_TIME_FROM', date_from: time });

  chooseTimeRangeTo = (moment, time) => this.props.dispatch({ type: 'SET_TRANSPORT_OPTIONS_TIME_TO', date_to: time });

  disabledDate = current => current && current < moment().endOf('day').add(2, 'days');

  disabledRangeTime = (_, type) => {
      if (type === 'start') {
          return {
              disabledHours: () => rangeHoursFrom,
          };
      }
      if (this.props.date_from) {
          return {
              disabledHours: () => rangeHoursTo.concat(range(9, +this.props.date_from.slice(10, 13) + 1)),
          };
      }
  };

  render() {
      const { tab, date_from, date_to } = this.props;
      const picker = () => {
          switch (tab) {
          case 0:
              return (
                  <DatePicker
                      style={{ width: '40%' }}
                      placeholder="Select Day/Time"
                      disabledDate={this.disabledDate}
                      disabledTime={() => ({ disabledHours: () => rangeHoursFrom })}
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                      onChange={(moment, time) => this.chooseDayTime(moment, time, 'DatePicker')}
                  />
              );
          case 1:
              return (
                  <Fragment>
                      <DatePicker
                          style={{ width: '35%' }}
                          disabledDate={this.disabledDate}
                          placeholder="Select Day"
                          onChange={this.chooseDayTime}
                      />
                      <TimePicker
                          style={{ width: '35%', margin: '0 5px 0 5px' }}
                          placeholder="Select Time From"
                          disabledHours={() => tHoursFrom}
                          format="HH:mm"
                          disabled={!(date_from && date_to)}
                          onChange={this.chooseTimeRangeFrom}
                      />
                      <TimePicker
                          style={{ width: '35%' }}
                          format="HH:mm"
                          disabledHours={() => tHoursTo.concat(range(9, +date_from.slice(10, 13) + 1))}
                          disabled={!(date_from && date_to)}
                          placeholder="Select Time To"
                          onChange={this.chooseTimeRangeTo}
                      />
                  </Fragment>
              );
          case 2:
              return (
                  <RangePicker
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                      disabledTime={this.disabledRangeTime}
                      disabledDate={this.disabledDate}
                      style={{ width: '70%' }}
                      onChange={(moment, time) => this.chooseDayTime(moment, time, 'RangePicker')}
                  />
              );
          default:
              return null;
          }
      };

      return (
          <Fragment>
              {tab === 0 ? <h3 style={{ textAlign: 'center' }}>Choose your collection date and time</h3> : tab === 1 ? <h3 style={{ textAlign: 'center' }}>Choose your collection date</h3> : <h3 style={{ textAlign: 'center' }}>Choose your collection date range</h3> }
              <div className="datepicker-position">{picker()}</div>
          </Fragment>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/TransportModalViews/ChooseDateTimeView.js